
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programowanie-nordic-nrf",
      function () {
        return require("private-next-pages/programowanie-nordic-nrf.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programowanie-nordic-nrf"])
      });
    }
  